export default "__VITE_ASSET__DpYiu1S0__"